import { useEffect, useState } from 'react';

/**
 * The natural width of an image (the cover), read in the browser; null while it loads, when it
 * fails, or with no url. The motion artwork note reads it (design w, "Cover size").
 */
export function useImageWidth(url: string | null | undefined): number | null {
  const [width, setWidth] = useState<number | null>(null);
  useEffect(() => {
    setWidth(null);
    if (url === null || url === undefined || url === '' || typeof Image === 'undefined') {
      return undefined;
    }
    let live = true;
    const image = new Image();
    image.onload = () => {
      if (live && image.naturalWidth > 0) {
        setWidth(image.naturalWidth);
      }
    };
    image.src = url;
    return () => {
      live = false;
    };
  }, [url]);
  return width;
}
